import { render, staticRenderFns } from "./Collective.vue?vue&type=template&id=3819069a&scoped=true&"
import script from "./Collective.vue?vue&type=script&lang=js&"
export * from "./Collective.vue?vue&type=script&lang=js&"
import style0 from "./Collective.vue?vue&type=style&index=0&id=3819069a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3819069a",
  null
  
)

export default component.exports